export const urlFormatRegExp: RegExp =
    /^(http(s)?:\/\/.)(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#!?&//=]*)$/

export const uuidRegex: RegExp =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export const ARABIC_TEXT_REGEX: RegExp = /[\u0600-\u06FF]/
